import OpenAI from 'openai';

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
});

interface LotteryInfo {
  timeLeft: string;
  participants: number;
  totalTickets: number;
  prizePool: string;
}

export const generateAIMessage = async (lotteryInfo: LotteryInfo) => {
  try {
    // Extraire les valeurs numériques du timeLeft (format: "Xd Xh Xm Xs")
    const timeComponents = lotteryInfo.timeLeft.split(' ');
    const days = parseInt(timeComponents[0]) || 0;
    const hours = parseInt(timeComponents[1]) || 0;
    const minutes = parseInt(timeComponents[2]) || 0;
    const seconds = parseInt(timeComponents[3]) || 0;

    // Calculer le temps total en minutes
    const totalMinutes = (days * 24 * 60) + (hours * 60) + minutes + (seconds > 0 ? 1 : 0);

    let timeDescription;
    if (totalMinutes === 0) {
      timeDescription = "The lottery has ended";
    } else if (totalMinutes === 1) {
      timeDescription = "just 1 minute";
    } else if (totalMinutes < 60) {
      timeDescription = `${totalMinutes} minutes`;
    } else if (totalMinutes < 1440) { // moins de 24h
      const remainingHours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;
      timeDescription = `${remainingHours} hours and ${remainingMinutes} minutes`;
    } else {
      timeDescription = `${days} days, ${hours} hours and ${minutes} minutes`;
    }

    const completion = await openai.chat.completions.create({
      model: "gpt-4-1106-preview",
      messages: [
        {
          role: "system",
          content: `You are DeepZephyr, an AI managing a lottery on the Solana blockchain. You provide updates about the lottery status. Keep responses engaging and concise. Use emojis to enhance the message. Format time remaining as: ${lotteryInfo.timeLeft}. Current participants: ${lotteryInfo.participants}. Total tickets: ${lotteryInfo.totalTickets}. Prize pool: ${lotteryInfo.prizePool}.`
        },
        {
          role: "user",
          content: `Create an update about the lottery with these details:
          - Time remaining: ${timeDescription}
          - Number of participants: ${lotteryInfo.participants}
          - Total tickets: ${lotteryInfo.totalTickets}
          - Prize pool: ${lotteryInfo.prizePool}`
        }
      ],
      temperature: 0.7,
      max_tokens: 200,
    });

    return completion.choices[0]?.message?.content || "No response generated";
  } catch (error) {
    return "I apologize, but I'm unable to provide an update at this moment. Please check the dashboard for current lottery status.";
  }
}; 